module.exports = __webpack_public_path__ + "img/dashboard-main-desktop-en.e3f43b25.jpg";